import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	badge: {
		backgroundColor: THEME.colors.success.main,
		// 4px keeps this flush with the Comp / Free Trial / Past Due badges rendered beside it in the account header.
		borderRadius: 4,
		color: THEME.colors.primary.contrastText,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: 0.5,
		paddingBlock: 2,
		paddingInline: THEME.spacing.sm,
		textTransform: 'uppercase' as const,
		whiteSpace: 'nowrap' as const,
	},
});
